import type { Attachment } from '@tadpoles/common'
import { isHlsAttachment } from './is-hls-attachment.js'

export function isVideoAttachment(attachment: Readonly<Attachment>): boolean {
    return attachment.mimeType.toLowerCase().startsWith('video/') || isHlsAttachment(attachment)
}
